import { AppBar, Stack, Toolbar, Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo.png'
import './Header.scss'
import ProfileDropdown from '../../shared/Profile/Profile'
import { useSelector } from "react-redux";

const Header = ({ showLoginButton }) => {
    const userdetail = useSelector((state) => state.mainSlice.userdetail);

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: 1201,
                backgroundColor: "#4caf50",
                color: "white",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
            }}
        >
            <Toolbar
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingY: 1
                }}
            >
                <Stack direction="row" alignItems="center">
                    <img src={logo} alt="Logo" style={{ height: "50px" }} />
                </Stack>

                {/* Show Login button (e.g. on scholarship form) or Profile when logged in */}
                {showLoginButton && !userdetail?.token ? (
                    <Button
                        component={Link}
                        to="/"
                        variant="outlined"
                        size="large"
                        sx={{
                            color: 'white',
                            borderColor: 'white',
                            fontSize: '1rem',
                            padding: '8px 24px',
                            minHeight: 44,
                            '&:hover': {
                                borderColor: 'white',
                                backgroundColor: 'rgba(255,255,255,0.1)'
                            }
                        }}
                    >
                        Login
                    </Button>
                ) : userdetail?.token && <ProfileDropdown />}
            </Toolbar>
        </AppBar>
    )
}

export default Header
